"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDateComponentParameters = void 0;
exports.UserDateComponentParameters = [
    {
        id: 'startRange',
        label: 'Start Range',
        description: 'Input Param - The start range for the date selection (in integer format)',
        type: 'int',
        required: false,
        paramType: 'INT',
    },
    {
        id: 'endRange',
        label: 'End Range',
        description: 'Input Param - The end range for the date selection (in integer format)',
        type: 'int',
        required: false,
        paramType: 'INT',
    },
    {
        id: 'preFill',
        label: 'Pre-fill Value',
        description: 'Input Param - A pre-filled value for the date field',
        type: 'string',
        required: false,
        paramType: 'STRING',
    },
    {
        id: 'outputDate',
        label: 'Output Date',
        description: 'Output Param - The date value selected by the user',
        type: 'output',
        paramType: 'STRING',
        required: true,
    },
];
//# sourceMappingURL=UserDateComponent.js.map